<div class="front-page">
  <p *ngIf="!loginDisplay" class="lead"><app-login-button></app-login-button></p>

  <div *ngIf="loginDisplay" class="front-links">
    <h4>Quick links</h4>
    <ul>
      <li><a routerLink="/service">Service Requests</a></li>
      <li><a routerLink="/assets">Assets</a></li>
      <li><a routerLink="/products">Products</a></li>
    </ul>
  </div>
</div>
